import { BetaPageHeader, Button } from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import { useTranslations } from "@zapier/i18n";

import styles from "./AppsHeader.module.css";
import { ConnectionsViewSelect } from "../../connections/ConnectionsHeader/ConnectionsViewSelect";
import { AppsFilterBar } from "../AppsFilters/AppsFilterBar";

interface AppsHeaderProperty {
  onAddConnection: () => void;
}

function AppsHeader({ onAddConnection }: AppsHeaderProperty) {
  const t = useTranslations("apps-header");

  return (
    <BetaPageHeader
      title={t("headings.page-title")}
      actions={
        <Button
          variant="primary"
          size="medium"
          onPress={onAddConnection}
          iconPosition="start"
        >
          <Icon name="formAdd" aria-hidden={true} />
          {t("buttons.create-connection")}
        </Button>
      }
      additionalContent={
        <div className={styles.midRow}>
          <ConnectionsViewSelect />
          <div className={styles.filterBar}>
            <AppsFilterBar />
          </div>
        </div>
      }
    />
  );
}

export default AppsHeader;
